import { render } from "./FirRequestType.vue?vue&type=template&id=23c5f6f8"
import script from "./FirRequestType.vue?vue&type=script&lang=js"
export * from "./FirRequestType.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__